import { ProcessCompletedBrandGradientIcon } from "./BridgeProcessDetailsIcons"

export const BTCConfirmationsIcon = () => {
  return <ProcessCompletedBrandGradientIcon />
}

export const MintingInitializedIcon = () => {
  return (
    <svg
      width="118"
      height="118"
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.905 23.3947C106.258 25.4534 106.496 29.0298 104.438 31.3826L48.4463 95.3728C45.3989 98.8555 40.0411 99.0339 36.7688 95.7616L13.8349 72.8276C11.6242 70.6169 11.6242 67.0327 13.8349 64.822V64.822C16.0456 62.6113 19.6298 62.6113 21.8405 64.822L36.2173 79.1988C39.4896 82.4711 44.8474 82.2927 47.8948 78.81L95.9172 23.9272C97.976 21.5744 101.552 21.3359 103.905 23.3947V23.3947Z"
        fill="url(#paint0_linear_8221_233758)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8221_233758"
          x1="12.7383"
          y1="22.9041"
          x2="108.786"
          y2="89.8022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F55B5B" />
          <stop offset="1" stopColor="#FAAD14" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const GuardianCheckIcon = () => {
  return (
    <svg
      width="118"
      height="118"
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.905 23.3947C106.258 25.4534 106.496 29.0298 104.438 31.3826L48.4463 95.3728C45.3989 98.8555 40.0411 99.0339 36.7688 95.7616L13.8349 72.8276C11.6242 70.6169 11.6242 67.0327 13.8349 64.822V64.822C16.0456 62.6113 19.6298 62.6113 21.8405 64.822L36.2173 79.1988C39.4896 82.4711 44.8474 82.2927 47.8948 78.81L95.9172 23.9272C97.976 21.5744 101.552 21.3359 103.905 23.3947V23.3947Z"
        fill="url(#paint0_linear_8221_234415)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8221_234415"
          x1="12.7383"
          y1="22.9041"
          x2="108.786"
          y2="89.8022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8FFF00" />
          <stop offset="1" stopColor="#48BB78" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const MintingCompletedIcon = () => {
  return (
    <svg
      width="118"
      height="118"
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.905 23.3947C106.258 25.4534 106.496 29.0298 104.438 31.3826L48.4463 95.3728C45.3989 98.8555 40.0411 99.0339 36.7688 95.7616L13.8349 72.8276C11.6242 70.6169 11.6242 67.0327 13.8349 64.822V64.822C16.0456 62.6113 19.6298 62.6113 21.8405 64.822L36.2173 79.1988C39.4896 82.4711 44.8474 82.2927 47.8948 78.81L95.9172 23.9272C97.976 21.5744 101.552 21.3359 103.905 23.3947V23.3947Z"
        fill="url(#paint0_linear_8221_235083)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8221_235083"
          x1="-4709.87"
          y1="35.5213"
          x2="-4709.59"
          y2="117.996"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#31DCED" />
          <stop offset="0.09" stopColor="#4FC4EC" />
          <stop offset="0.25" stopColor="#809EEB" />
          <stop offset="0.41" stopColor="#A87EEB" />
          <stop offset="0.57" stopColor="#C765EA" />
          <stop offset="0.73" stopColor="#DE53E9" />
          <stop offset="0.87" stopColor="#EB49E9" />
          <stop offset="1" stopColor="#F045E9" />
        </linearGradient>
      </defs>
    </svg>
  )
}
